import { AdditionalInformation } from '@hivebrite/design-system/AdditionalInformation';
import { Box } from '@hivebrite/design-system/Box';

import { useEventContext } from 'hb-react/shared/apps/Events/contexts/EventContext';
import { useIsLoginRequired } from 'hb-react/shared/apps/Events/hooks/useIsLoginRequired';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

export const TicketsAdditionalInfo = () => {
  const { event } = useEventContext();
  const { flagEvImproveSoldOutEventsFo } = useFeatureFlag();
  const requiresLogin = useIsLoginRequired(event);

  if (!flagEvImproveSoldOutEventsFo || requiresLogin) {
    return null;
  }

  if (event.participation_type !== 'tickets') {
    return null;
  }

  if (event.registration_status === 'limit_reached_for_current_user')
    return (
      <Box mb={4} display="block">
        <AdditionalInformation id="tickets-additonal-info" type="error">
          {s__(
            'Events|You have reached the maximum number of tickets allowed per user.',
          )}
        </AdditionalInformation>
      </Box>
    );

  if (event.registration_status === 'fully_booked') {
    return (
      <Box mb={4} display="block">
        <AdditionalInformation id="tickets-additonal-info" type="error">
          {s__('Events|This event is fully booked.')}
        </AdditionalInformation>
      </Box>
    );
  }

  return null;
};
